import { useStore } from '../../../../contexts/StoreContext';
import amplitude from 'src/_shared/amplitude';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import BaseModal from '../../base-modal/BaseModal';
import { View } from 'react-native';
import { Illustration } from '../../../illustration/Illustration';
import { ILLUSTRATION_NAMES } from '../../../illustration/illustration.helper';
import { TestIDs } from 'src/constants/testIDs.constants';
import { DynamicModalProps } from '../DynamicModal.types';

export const ModalEmptyImages = ({ type, dynamicModalVisible, dynamicModalLayer: { id } }: DynamicModalProps) => {
  const {
    i18n,
    dynamicModal: { closeModal },
    project: { setActiveProduct, activeProject, isProductSetProject },
  } = useStore();

  return (
    <BaseModal
      testID={TestIDs.EMPTY_IMAGES}
      modalIcon={
        <View style={{ width: 100, height: 100 }}>
          <Illustration name={!isProductSetProject ? ILLUSTRATION_NAMES.Empty : ILLUSTRATION_NAMES.AddPhoto} />
        </View>
      }
      title={i18n.t(!isProductSetProject ? 'modal-empty-images:title' : 'modal-empty-images:title-adhesive')}
      description={i18n.t(
        !isProductSetProject ? 'modal-empty-images:description' : 'modal-empty-images:description-adhesive',
      )}
      handleConfirm={() => {
        closeModal();
        setActiveProduct(activeProject?.firstBlankProductIndex);
        amplitude.trackEvent(AnalyticsEvents.personalize.emptySpaceAlertClick, { action: 'verify' });
      }}
      confirmText={i18n.t(!isProductSetProject ? 'modal-empty-images:check' : 'modal-empty-images:check-adhesive')}
      onClose={closeModal}
      onCloseOutside={closeModal}
      isVisible={dynamicModalVisible}
      type={type}
      id={id}
    />
  );
};
